export const EMPLOYEE_GRADE_ANALYTICS_EVENTS = {
  EMPLOYEE_GRADE_CREATE: "employee-grade-create",
  EMPLOYEE_GRADE_UPDATE: "employee-grade-update",
  EMPLOYEE_GRADE_DELETE: "employee-grade-delete",
  EMPLOYEE_GRADE_STATUS_TOGGLE: "employee-grade-status-toggle",
  EMPLOYEE_GRADE_FETCH: "employee-grade-fetch",
};
